export default {
  data () {
    return {
      loading: {}
    }
  },

  methods: {
    setLoading (state) {
      this.loading = state
    },

    setTempLoading (el) {
      this.loading = el

      setTimeout(() => {
        this.loading = null
      }, 1000)
    },

    getNewSortOrder (newOrderBy, orderBy, sortOrder) {
      if (newOrderBy === orderBy) {
        return sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        return 'asc'
      }
    }
  }
}
